import RHServiceModel from '@/models/RHServiceModel';
import { computed }   from 'mobx';
import config         from '@/config';
import doc            from '@widesk-core/decorators/doc';
import model          from '@widesk-core/decorators/model';

const colors: Record<CandidacyStatusReference, string> = {
	TO_FINISH_BY_CANDIDATE: "gray",
	TO_PROCESS: "gray",
	INTERVIEW_PROPOSED: "gray",
	INTERVIEW_ACCEPTED: "green",
	INTERVIEW_MISSED: "red",
	TO_CALL_AGAIN: "gray",
	WAITING_FOR_RATING: "gray",
	WAITING_FOR_OPINION: "gray",
	RESERVIST_PROPOSED: "gray",
	RESERVIST: "gray",
	WAITING_JOB_OFFER: "gray",
	JOB_OFFERED: "gray",
	JOB_ACCEPTED: "gray",
	JOB_REFUSED: "green",
	CONTRACT_TO_SIGN: "gray",
	CONTRACT_SIGNED: "green",
	REFUSED: "red",
	CANCELED_BY_CANDIDATE: "red",
	SCHEDULE_SEIZURE: "gray",
	SCHEDULE_VERIFICATION: "gray",
	PAY_STUB_SEIZURE: "gray",
	PAY_STUB_EDITION: "gray",
	SENDING_PAY_STUB: "gray",
	PAYMENT_TO_SIGN: "gray",
	PAYMENT_DONE: "green",
	DOCUMENTS_TO_SEND: "green",
	DOCUMENTS_SENT: "gray",
	RESERVIST_NOT_EMPLOYED: "gray",
  };

@model.urnResource('candidacy')
@doc.path('/candidacies/candidacies/me/{?id}')
export default class CandidacyModel extends RHServiceModel {
	private declare _tsFilters: {
		'o': string;
		'w': string;
		'user': string;
	};

	get title(): string {
		return this.get('campaign_title', '');
	}

	get entertainmentTitle(): string {
		return this.get('campaign_entertainment_data.title', '');
	}

	get statusReference(): CandidacyStatusReference {
		return this.get('candidacy_step_reference');
	}

	get campaignUrl(): string {
		return this.get('campaign.Url.action');
	}

	get campaignPictureId(): number {
		return this.get('campaign_picture.File.id');
	}

	get campaignPictureSecret(): string {
		return this.get('campaign_picture.File.url.Url.parameters.secret');
	}

	get privateCampaignPictureUrl(): string {
		return config.api_endpoint + `/monolith/files/${this.campaignPictureId}/content?secret=${this.campaignPictureSecret}`;
	}

	get url(): string {
		return config.rh_url + `/#/candidacies/dashboard/${this.id}`;
	}

	@computed
	public get color(): string {
		return colors[this.statusReference];
	}
}